<div>


    <div class="sw-category-detail-topfeed">
        <sw-card :title="$tc('TopdataProductBoxesSW6.productBoxSettings.cardTitle')">

            <sw-loader
                    v-show="isLoading"
                    size="48px"
            ></sw-loader>

            <div v-if="topdataPbCategoryExtension">


                <sw-switch-field
                        v-if="topdataPbCategoryExtension"
                        :label="$tc('TopdataProductBoxesSW6.productBoxSettings.useParentCategory')"
                        v-model:value="topdataPbCategoryExtension.useParentCategory"
                ></sw-switch-field>

                <div v-if="topdataPbCategoryExtension.useParentCategory === false">


                    <sw-switch-field
                            :label="$tc('TopdataProductBoxesSW6.productBoxSettings.isEnabled')"
                            v-model:value="topdataPbCategoryExtension.isEnabled"
                    ></sw-switch-field>


                    <div v-if="topdataPbCategoryExtension.isEnabled">

                        <p class="topdata-pb-property-groups__hint" style="margin: 0 0 8px 0;">
                            {{ $tc('TopdataProductBoxesSW6.productBoxSettings.propertyGroupIds.hint') }}
                        </p>

                        <sw-loader v-if="isLoadingGroups" size="30px"></sw-loader>

                        <div v-else-if="propertyGroupSelectOptions.length === 0" class="topdata-pb-property-groups__empty">
                            {{ $tc('TopdataProductBoxesSW6.productBoxSettings.propertyGroupIds.empty') }}
                        </div>

                        <template v-else>

                            <sw-multi-select
                                    :value="selectedPropertyGroupIds"
                                    :options="propertyGroupSelectOptions"
                                    :label="$tc('TopdataProductBoxesSW6.productBoxSettings.propertyGroupIds.label')"
                                    :placeholder="$tc('TopdataProductBoxesSW6.productBoxSettings.propertyGroupIds.placeholder')"
                                    :disabled="isLoading"
                                    @update:value="onPropertyGroupChange"
                            ></sw-multi-select>

                            <sw-multi-select
                                    :value="selectedDetailPropertyGroupIds"
                                    :options="propertyGroupSelectOptions"
                                    :label="$tc('TopdataProductBoxesSW6.productBoxSettings.detailPropertyGroupIds.label')"
                                    :placeholder="$tc('TopdataProductBoxesSW6.productBoxSettings.detailPropertyGroupIds.placeholder')"
                                    :disabled="isLoading"
                                    style="margin-top: 16px;"
                                    @update:value="onDetailPropertyGroupChange"
                            ></sw-multi-select>

                        </template>

                    </div>

                </div>

            </div>

        </sw-card>
    </div>


</div>
